export const emptyParticipant = {
  firstName: "",
  lastName: "",
  email: "",
  registrationType: "",
  proceedingsFormat: "",
  tShirt: "",
  tShirtSize: "",
  specialDietary: "",
  payload: "",
  workshops: [],
  events: [],
  terms: [],
};
